var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientBlue = function SvgPatientBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#4A657B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.511 10.328c2.857 0 5.164 2.136 5.164 4.757 0 .242-.198.44-.44.44-.241 0-.439-.198-.439-.44 0-2.159-1.934-3.898-4.307-3.898s-4.285 1.762-4.285 3.898c0 .242-.198.44-.44.44-.241 0-.439-.198-.439-.44.022-2.621 2.33-4.757 5.186-4.757zm1.187 1.52c.241 0 .44.198.44.44l-.001.924h.945c.242 0 .44.199.44.441s-.22.44-.462.44h-.923v.903c-.022.243-.22.44-.44.44-.241 0-.439-.197-.439-.44v-.903h-.945c-.242 0-.44-.198-.44-.44s.198-.44.44-.44l.945-.001v-.924c0-.242.198-.44.44-.44zM11.51 5.174c1.384 0 2.505 1.079 2.505 2.422 0 1.344-1.12 2.423-2.505 2.423-1.384 0-2.505-1.08-2.505-2.423s1.12-2.422 2.505-2.422zm0 .859c-.901 0-1.648.705-1.648 1.563 0 .86.747 1.564 1.648 1.564.9 0 1.648-.705 1.648-1.564 0-.858-.747-1.563-1.648-1.563z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-blue.a7a390e950973d9f236acb63de6ef77b.svg";